import React from 'react';
import { Link } from 'react-router-dom';

export default function Ticker({ items = [] }) {
  const defaultItems = [
    { title: "Nye ejendomsvurderinger for 2026 er udsendt til boligejere", url: "/artikler/nye-ejendomsvurderinger-2026-boligejere" },
    { title: "Skattestyrelsen varsler skærpet kontrol med SMV-momsangivelser", url: "/artikler/ny-kontrolboelge-rammer-smver-momsangivelser" },
    { title: "Kørselsfradrag: Vær opmærksom på dokumentation ved hjemmearbejde", url: "/artikler/koerselsfradrag-hjemmearbejdsdage-faldgruber" },
  ];

  const newsItems = items.length > 0 ? items : defaultItems;
  // Sørg for tilstrækkelig længde per halvdel til en ubrudt rulletekst
  const trackItems = newsItems.length < 5 ? [...newsItems, ...newsItems] : newsItems;

  return (
    <div className="border-y border-[#010b27] bg-[#010b27] text-white py-2 px-4">
      <div className="mx-auto max-w-7xl flex items-center gap-4 overflow-hidden text-xs">
        <div className="z-10 flex items-center gap-1.5 shrink-0 bg-[#fd7302] text-white px-2.5 py-0.5 rounded-xs font-bold uppercase tracking-wider text-[10px] shadow-xs">
          <span className="inline-block h-1.5 w-1.5 rounded-full bg-white animate-pulse" />
          <span>Fokus lige nu</span>
        </div>
        <div className="relative flex-1 overflow-hidden py-0.5 select-none">
          <div className="flex items-center whitespace-nowrap animate-ticker-marquee">
            {/* Primær sekvens */}
            <div className="flex items-center shrink-0">
              {trackItems.map((item, idx) => (
                <Link
                  key={`track-a-${idx}`}
                  to={item.url || '/artikler'}
                  className="inline-flex items-center gap-2 text-slate-200 hover:text-[#fd7302] transition-colors focus:outline-none text-xs mr-8"
                >
                  <span className="text-[#fd7302] text-[9px]">◆</span>
                  <span className="hover:underline underline-offset-2">{item.title}</span>
                </Link>
              ))}
            </div>
            {/* Duplikatsekvens for sømløst uendeligt loop uden hop */}
            <div className="flex items-center shrink-0" aria-hidden="true">
              {trackItems.map((item, idx) => (
                <Link
                  key={`track-b-${idx}`}
                  to={item.url || '/artikler'}
                  tabIndex={-1}
                  className="inline-flex items-center gap-2 text-slate-200 hover:text-[#fd7302] transition-colors focus:outline-none text-xs mr-8"
                >
                  <span className="text-[#fd7302] text-[9px]">◆</span>
                  <span className="hover:underline underline-offset-2">{item.title}</span>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
